import { render, staticRenderFns } from "./intervencionesShow.vue?vue&type=template&id=66a5bb62&scoped=true&"
import script from "./intervencionesShow.vue?vue&type=script&lang=js&"
export * from "./intervencionesShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a5bb62",
  null
  
)

export default component.exports